<template>
  <div class="simple-select-search">
    <button
      class="btn justify-start"
      :class="{ focus: isModalShow }"
      :style="{ width: `${buttonWidth}` }"
      @click="isModalShow = !isModalShow"
    >
      <span
        v-if="(selectedValue === '' || !selectedValue) && isOnlyShowButtonPlaceholder"
        :class="{ 'ink-01-emphasis--text': isModalShow }"
        >{{ buttonPlaceholder }}</span
      >
      <span v-else class="ink-01-emphasis--text">
        <slot name="textOnButton" :selectedValue="textOnButton">
          {{ textOnButton }}
        </slot>
      </span>
      <v-icon class="ml-auto">arrow_drop_down</v-icon>
    </button>
    <div
      v-if="isModalShow"
      class="simple-select-search__modal block block-3"
      :style="{ width: `${modalWidth}`, top: `${modalTop}` }"
    >
      <div class="simple-select-search__head">
        <div class="form-input-group">
          <v-icon class="prepend-icon">search</v-icon>
          <input
            type="text"
            class="pl-42px"
            :placeholder="inputPlaceholder"
            v-model="filterText"
          />
        </div>
      </div>
      <div
        class="simple-select-search__body"
        :style="{ 'max-height': `${modalBodyHeight}` }"
      >
        <div
          v-for="item in filterOptions"
          :key="item[itemValue]"
          class="simple-select-search__item selection-item-hover"
          @click="selectItem(item)"
        >
          <slot name="option" :option="item">{{ item[itemText] }}</slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Zeplin: https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f2d7258fe475221817abd85

export default {
  props: {
    buttonPlaceholder: {
      type: String,
      default: '篩選項目',
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },
    isOnlyShowButtonPlaceholder: {
      type: Boolean,
      default: false,
    },
    buttonWidth: {
      type: String,
      default: '160px',
    },
    modalWidth: {
      type: String,
      default: '360px',
    },
    modalBodyHeight: {
      type: String,
      default: '408px',
    },
    modalTop: {
      type: String,
      default: 'auto',
    },
    selectedValue: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default: () => [
        {
          value: 1,
          title: 'option1',
        },
      ],
    },
    limitOfWordLengthInInput: {
      type: Number,
      default: 14,
    },
    itemValue: {
      type: String,
      default: 'value',
    },
    itemText: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      isModalShow: false,
      filterText: '',
      textOnBtn: '',
    };
  },
  created() {
    if (this.selectedValue !== '' && this.selectedValue !== null) {
      const textOnBtn = this.options.find((o) => o[this.itemValue] === this.selectedValue);
      this.textOnBtn = textOnBtn[this.itemText];
    }
  },
  computed: {
    filterOptions() {
      if (typeof this.options[0] === 'number') {
        if (this.filterText === '') {
          return this.options;
        }
        return this.options.filter((item) =>
          String(item).includes(String(this.filterText)),
        );
      }

      return this.options.filter((item) =>
        item[this.itemText].toLowerCase().includes(this.filterText),
      );
    },
    textOnButton() {
      let { selectedValue } = this;

      if (typeof selectedValue === 'number') {
        selectedValue = String(selectedValue);
      }

      return this.textOnBtn.length < this.limitOfWordLengthInInput
        ? this.textOnBtn
        : `${this.textOnBtn.slice(0, 10)}...`;
    },
  },
  methods: {
    selectItem(item) {
      this.textOnBtn = item[this.itemText];
      this.$emit('update:selectedValue', item[this.itemValue]);
      this.filterText = '';
      this.isModalShow = false;
    },
  },
};
</script>

<style lang="scss">
.simple-select-search {
  position: relative;

  &__modal {
    position: absolute;
    margin-top: 5px;
    z-index: 1;
    background-color: #fff;
  }
  &__head {
    padding: 10px;
    box-shadow: inset 0 -1px 0 0 #d7dee7;
  }

  &__body {
    overflow: auto;
  }
  &__item {
    display: flex;
    align-items: center;
    height: 48px;
    padding-left: 10px;
    font-size: 14px;
    line-height: 1.43;
    cursor: pointer;
  }
}
</style>
